var map = {
	"./01_agata.png": 1385,
	"./02_baltneta.png": 2181,
	"./03_bio.png": 3457,
	"./04_fletech.png": 4249,
	"./05_gp_transco.png": 722,
	"./05_kesko_senukai.png": 350,
	"./06_avaka.png": 1951,
	"./07_ziniu_radijas.png": 8020,
	"./08_capital.png": 9346,
	"./09_eika.png": 2082,
	"./10_luminor.png": 8980,
	"./11_popri.png": 1749,
	"./12_small_planet.png": 37,
	"./13_seb.png": 3412,
	"./14.png": 9267,
	"./15_agro.png": 3625,
	"./bpt.png": 6748,
	"./lexano_logo_lt_LT.png": 1136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2418;